export default function belongsTo(type) {
  return function (target, key) {
    if (!target.constructor.relationships) {
      target.constructor.relationships = [];
    }
    target.constructor.relationships.push({modelName: type, propertyName: key});
  };
}
 